import React, { useEffect, useMemo, useState } from 'react';
import Input from '../ui/Input.jsx';
import {
  decimalHoursToParts,
  partsToDecimalHours
} from '../utils/profileForm.js';

export default function DurationHoursMinutesInput({
  value,
  onChange,
  maxHours,
  hourLabel = 'Heures',
  minuteLabel = 'Minutes'
}) {
  const derivedParts = useMemo(() => decimalHoursToParts(value), [value]);
  const [hours, setHours] = useState(derivedParts.hours);
  const [minutes, setMinutes] = useState(derivedParts.minutes);

  useEffect(() => {
    setHours(derivedParts.hours);
    setMinutes(derivedParts.minutes);
  }, [derivedParts.hours, derivedParts.minutes]);

  const emitChange = (nextHours, nextMinutes) => {
    onChange(partsToDecimalHours({
      hours: nextHours,
      minutes: nextMinutes
    }));
  };

  return (
    <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)_auto] gap-2 items-end">
      <div className="space-y-1">
        <div className="text-xs font-medium text-ptcm-muted dark:text-gray-400">{hourLabel}</div>
        <Input
          type="number"
          min={0}
          max={maxHours}
          step={1}
          inputMode="numeric"
          value={hours}
          onChange={(e) => {
            const nextHours = e.target.value;
            setHours(nextHours);
            emitChange(nextHours, minutes);
          }}
        />
      </div>
      <div className="pb-3 text-sm font-medium text-ptcm-muted dark:text-gray-400">h</div>
      <div className="space-y-1">
        <div className="text-xs font-medium text-ptcm-muted dark:text-gray-400">{minuteLabel}</div>
        <Input
          type="number"
          min={0}
          max={59}
          step={1}
          inputMode="numeric"
          value={minutes}
          onChange={(e) => {
            const nextMinutes = e.target.value;
            setMinutes(nextMinutes);
            emitChange(hours, nextMinutes);
          }}
        />
      </div>
      <div className="pb-3 text-sm font-medium text-ptcm-muted dark:text-gray-400">min</div>
    </div>
  );
}
